(function () {
  'use strict';
  if (document.documentElement.getAttribute('data-rudca-product-subscriptions-paused') !== 'true') return;
  var addFormSelector = 'form[action*="/cart/add"]';
  function formFor(node) { return node && node.closest ? node.closest(addFormSelector) : null; }
  function membership(form) { return Boolean(form && (form.matches('[data-rudca-membership-product]') || form.querySelector('[data-rudca-membership-product]') || form.closest('[data-rudca-membership-product]'))); }
  function managed(form) { return Boolean(form && form.matches(addFormSelector) && !membership(form) && (form.querySelector('[data-rudca-one-time-product]') || form.closest('[data-rudca-one-time-card]'))); }
  function oneTimeAllowed(form) {
    if (!managed(form)) return true;
    var marker = form.querySelector('[data-rudca-one-time-product]');
    if (!marker) return true;
    var node = marker.querySelector('[data-rudca-one-time-variants]'), id = form.querySelector('[name="id"]'), rules;
    try { rules = node && JSON.parse(node.textContent); } catch (ignored) { return false; }
    return Boolean(id && rules && rules[String(id.value)] === true);
  }
  function prepareForm(form) {
    if (!managed(form)) return;
    form.querySelectorAll('.appstle_sub_widget, [name="selling_plan"]').forEach(function (node) { node.remove(); });
    var unavailable = !oneTimeAllowed(form), notice = form.querySelector('[data-rudca-one-time-notice]');
    var text = notice && notice.getAttribute(unavailable ? 'data-required-notice' : 'data-one-time-label');
    if (notice && text && notice.textContent !== text) notice.textContent = text;
    if (unavailable) form.querySelectorAll('[data-action="add-to-cart"], [data-rudca-product-add], button[type="submit"]').forEach(function (button) { button.disabled = true; });
  }
  function canAdd(node) { var form = formFor(node); prepareForm(form); return oneTimeAllowed(form); }
  function acceptsAdd(body, node) {
    var form = formFor(node);
    if (!managed(form)) return true;
    return (!form || oneTimeAllowed(form)) && (!body || body.selling_plan === undefined || body.selling_plan === null || body.selling_plan === '');
  }
  function notice() {
    var root = document.querySelector('[data-section-type="cart"]') || document.querySelector('.mini-cart');
    return root && root.querySelector('[data-rudca-paused-subscription-lines]');
  }
  function sync() {
    document.querySelectorAll(addFormSelector).forEach(prepareForm);
    if (notice()) document.querySelectorAll('[name="checkout"], [data-rudca-cart-payment] button').forEach(function (button) { button.disabled = true; });
  }
  function guard(event) {
    var target = event.target, form = formFor(target);
    if (form) {
      prepareForm(form);
      if (!oneTimeAllowed(form) && (event.type === 'submit' || target.closest('[data-action="add-to-cart"], [data-rudca-product-add], button[type="submit"]'))) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    }
    var blocker = notice();
    if (!blocker) return;
    var checkout = target && target.closest && target.closest('[name="checkout"], a[href*="/checkout"], [data-rudca-cart-payment], .additional-checkout-buttons');
    var cartForm = event.type === 'submit' && target.matches('form') && new URL(target.action, location.href).pathname.replace(/\/$/, '') === (window.routes && window.routes.cartUrl || '/cart').replace(/\/$/, '');
    if (checkout || cartForm) { event.preventDefault(); event.stopImmediatePropagation(); blocker.focus({preventScroll: true}); }
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  document.addEventListener('change', function (event) { var form = formFor(event.target); if (form) prepareForm(form); });
  document.addEventListener('formdata', function (event) { if (managed(event.target)) event.formData.delete('selling_plan'); });
  document.addEventListener('cart:rerendered', sync);
  document.documentElement.addEventListener('rudca:cart-settled', sync);
  new MutationObserver(function (records) { if (records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; })) sync(); }).observe(document.documentElement, {childList: true, subtree: true});
  window.RudcaProductSubscriptionPause = {prepareForm: prepareForm, canAdd: canAdd, acceptsAdd: acceptsAdd};
  sync();
}());
